var _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSortUp = function SvgSortUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m24.118 12.318-8.813-8.814-8.814 8.814 2.121 2.121 5.193-5.193v33.129h3V9.246l5.192 5.193zm15.27 12.089L34.195 29.6V16.355h-3V29.6l-5.192-5.193-2.121 2.121 8.813 8.814 8.814-8.814z"
  })))));
};
export default SvgSortUp;